import {
  Calendar,
  CreditCard,
  Home,
  MessageSquare,
  User,
  Users,
  CalendarClock,
} from "lucide-react";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";

import { cn } from "@/lib/utils";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

interface Props {
  children: React.ReactNode;
}

export function MobileMenu() {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();

  const isPathActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <button
          className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-accent-foreground hover:bg-accent hover:text-accent-foreground h-9 w-9 p-0"
          aria-label="Toggle Navigation Menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
          <span className="sr-only">Toggle Navigation Menu</span>
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-64 sm:w-72">
        <SheetHeader className="mb-4">
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <nav className="grid gap-2">
          <Link
            to="/dashboard"
            className={cn(
              "flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium transition-all",
              isPathActive('/dashboard') && !isPathActive('/dashboard/')
                ? "bg-muted"
                : "hover:bg-muted/80"
            )}
            onClick={() => setIsOpen(false)}
          >
            <Home className="h-4 w-4" />
            <span>Dashboard</span>
          </Link>
          
          <Link
            to="/dashboard/prompts"
            className={cn(
              "flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium transition-all",
              isPathActive('/dashboard/prompts')
                ? "bg-muted"
                : "hover:bg-muted/80"
            )}
            onClick={() => setIsOpen(false)}
          >
            <MessageSquare className="h-4 w-4" />
            <span>Prompts</span>
          </Link>
          
          {/* Adicionar os novos links para a Agenda */}
          <div>
            <h3 className="mb-1 ml-2.5 text-xs font-medium text-muted-foreground">
              Agenda
            </h3>
            <div className="grid gap-1">
              <Link
                to="/dashboard/agenda"
                className={cn(
                  "flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium transition-all",
                  isPathActive('/dashboard/agenda')
                    ? "bg-muted"
                    : "hover:bg-muted/80"
                )}
                onClick={() => setIsOpen(false)}
              >
                <Calendar className="h-4 w-4" />
                <span>Calendário</span>
              </Link>
              
              <Link
                to="/dashboard/clients"
                className={cn(
                  "flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium transition-all",
                  isPathActive('/dashboard/clients')
                    ? "bg-muted"
                    : "hover:bg-muted/80"
                )}
                onClick={() => setIsOpen(false)}
              >
                <Users className="h-4 w-4" />
                <span>Clientes</span>
              </Link>
              
              <Link
                to="/dashboard/appointments"
                className={cn(
                  "flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium transition-all",
                  isPathActive('/dashboard/appointments')
                    ? "bg-muted"
                    : "hover:bg-muted/80"
                )}
                onClick={() => setIsOpen(false)}
              >
                <CalendarClock className="h-4 w-4" />
                <span>Compromissos</span>
              </Link>
            </div>
          </div>
          
          <Link
            to="/dashboard/profile"
            className={cn(
              "flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium transition-all",
              isPathActive('/dashboard/profile')
                ? "bg-muted"
                : "hover:bg-muted/80"
            )}
            onClick={() => setIsOpen(false)}
          >
            <User className="h-4 w-4" />
            <span>Perfil</span>
          </Link>
        </nav>
      </SheetContent>
    </Sheet>
  );
}

export default MobileMenu;
